export enum AccountStatus {
  ONBOARD = 1,
  CREATE_REQUESTED = 1,
  APPROVED = 2,
  REPROVED = 3,
  BLOCKED = 4,
  CANCELED = 5,
  REQUESTED_ADDRESS = 7,
  REQUESTED_SELF = 8,
  REQUESTED_DOCUMENTS = 9,
  REQUESTED_PIN = 10,
  PENDING_CREATE_COREBANK_CONFIRM = 11,
  PENDING_CREATE_COREBANK = 12,
  PENDING_ACCOUNT_DATA_RETRY = 14,
  PENDING_DOCUMENTS = 15,
  PENDING_APPROVAL = 16,
  PENDING_MANUAL_APPROVAL = 17,
  ERROR_TO_CREATE = 999,
}

export enum OperatorStatus {
  AWAITING_LOGIN = 1,
  AWAITING_LINKED = 2,
  LINKED = 3,
}
